// extracted by mini-css-extract-plugin
export default {"no-updates":"noUpdate_no-updates__rtWmv","button":"noUpdate_button__w6uSh"};